import { useEffect, useRef, useCallback } from 'react';

const CanvasDrawer = (props) => {
  const { width, height, backgroundImg, dataList } = props;
  const canvasTarget = useRef(null);

  const drawRectangle = useCallback((ctx, index, rectParams, proportion) => {
    let x = rectParams[0] * proportion;
    let y = rectParams[1] * proportion;
    ctx.beginPath();
    ctx.fillStyle = '#FFA500';
    ctx.font = 'bolder 16px "PingFangSC-Regular"';
    ctx.fillText(index + 1, x + 2, y + 12);
    ctx.closePath();
  }, []);

  const drawRectangularBox = useCallback(
    (ctx, index, rectParams, proportion) => {
      let x = rectParams[0][0] * proportion;
      let y = rectParams[0][1] * proportion;
      let rectWidth = (rectParams[1][0] - rectParams[0][0]) * proportion;
      let rectHeight = (rectParams[3][1] - rectParams[0][1]) * proportion;
      ctx.beginPath();
      if (index % 2 === 0) {
        ctx.setLineDash([5, 5]);
      } else {
        ctx.setLineDash([]);
      }
      ctx.lineWidth = 1;
      ctx.strokeStyle = '#84B0F0';
      ctx.rect(x, y, rectWidth, rectHeight);
      ctx.stroke();
      ctx.closePath();
    },
    []
  );

  const drawTitleNumber = useCallback((ctx, index, rectParams, proportion) => {
    drawRectangle(ctx, index, rectParams, proportion);
  }, []);

  useEffect(() => {
    if (!backgroundImg) {
      return;
    }
    const backgroundImgClone = backgroundImg.cloneNode(false); // 返回数据中的位置是按照图片原像素，页面图片是处理过的，故需要得出比例
    let proportion = width / backgroundImgClone.width;
    const ctx = canvasTarget.current.getContext('2d');
    ctx.clearRect(0, 0, width, height);
    ctx.drawImage(
      backgroundImg,
      0,
      0,
      width,
      backgroundImgClone.height * proportion
    );
    if (!dataList || !Array.isArray(dataList)) {
      return;
    }
    if (dataList.length > 0) {
      for (let i = 0; i < dataList.length; i++) {
        let { itemPos } = dataList[i][1];
        drawRectangularBox(ctx, i, itemPos, proportion);
        drawTitleNumber(ctx, i, itemPos[0], proportion);
      }
    }
  }, [
    backgroundImg,
    height,
    width,
    dataList,
    drawRectangularBox,
    drawTitleNumber
  ]);
  return (
    <canvas
      width={width}
      height={(backgroundImg.height * (width / backgroundImg.width)).toFixed(2)}
      ref={canvasTarget}
    />
  );
};

export default CanvasDrawer;
